import React, { Component } from "react"
import {
    Container,
    Card,
    CardBody,
    CardText,
    Row,
    Col,
    Table
} from "reactstrap"
import MetaTags from 'react-meta-tags'
import Message from "./Message"
import { connect } from "react-redux"
import { createPayPalOrder, approvePayPalOrder, reportOrderConfirm  } from "store/actions"

import pdficon from "assets/images/pdficon.jpg"

import PropsTypes from "prop-types"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";


class BirthChartPaymentInvoice extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showPaypalPaymentButton:false,
            reportId: '',
            invoiceDetails: {},
            actionResult: {},
            actionResultChanged: false,
            birthDetail: {
                invoiceAmount: 1000,
                invoiceCurrency: 'INR'
            }
        }

        this.makePayment = this.makePayment.bind(this)
    }


    // Function to call createOrderAction
    callCreateOrderAction = (data, actions) => {
        try {
            this.props.createOrderAction();
            return new Promise((resolve) => {
                const interval = setInterval(() => {
                    if (this.props.paypalOrder && !this.props.loading) {
                        clearInterval(interval);
                        resolve(this.props.paypalOrder.id);
                    }
                }, 100);
            });
        } catch (error) {
            console.error(error);
        }

    }

    // Function to call createOrderAction
    callApproveOrderAction = (data, actions) => {
        try {
            return new Promise((resolve, reject) => {
                this.props.approveeOrderAction(data.orderID, this.state.reportId);
                const interval = setInterval(() => {
                    // Check if order data is available
                    if (this.props.approvePaypalOrder && !this.props.loading) {
                        clearInterval(interval);
                        const orderData = this.props.approvePaypalOrder;
                        // Three cases to handle:
                        //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                        //   (2) Other non-recoverable errors -> Show a failure message
                        //   (3) Successful transaction -> Show confirmation or thank you message
                        const errorDetail = orderData?.details?.[0];
                        if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
                            return actions.restart();
                        } else if (errorDetail) {
                            let msg = 'Sorry, your transaction could not be processed.';
                            msg += errorDetail.description ? ' ' + errorDetail.description : '';
                            msg += details.debug_id ? ' (' + details.debug_id + ')' : '';
                            this.props.history.push({ pathname: "/payments/fail", state: { msg } })
                        } else {
                            //update the payment status to PAID, send email to Dr
                            this.props.reportOrderConfirmAction(this.state.reportId);
                            const transaction = orderData.purchase_units[0].payments.captures[0];
                            const data = "gatlmzcl" + Date.now() + "rqtxmzltag"
                            this.props.history.push({ pathname: "/payments/success/" + data, state: { transaction } })
                        }
                        resolve(); // Resolve the promise with the order data
                    }
                }, 100);

                // Set timeout to reject if order data is not available within certain time
                setTimeout(() => {
                    clearInterval(interval);
                    reject(new Error('Order data retrieval timeout'));
                }, 5000); // 5 seconds timeout
            });

        } catch (error) {
            console.error(error);
        }

    }

    makePayment() {
        console.log("payment status makePaymentSaga")
        localStorage.setItem("PaymentState", "Inititated");
        const birthDetail = this.state.birthDetail
        const paymentLink = birthDetail.paymentLink
        console.log("paymentLink: ", paymentLink)
        window.location.href = paymentLink
    }

    componentDidMount() {
        const payment = this.props.location.state?.birthDetail;
        this.setState({ reportId: payment.reportId })
        console.log("Report id from previous stage:::" + payment.reportId)
        // this.setState({ birthDetail })
    }

    // Renders errors or successfull transactions on the screen.
    Message({ content }) {
        return <p>{content}</p>;
    }
    render() {
        const { birthDetail, message, setMessage } = this.state
        const payment = this.props.location.state?.birthDetail;
        if (!payment) {
            console.log("Payment object from birthinput=" + payment.invoiceAmount)
        }
        //const payment = this.props.location.state?.birthDetail;
        //this.setState(payment)
        // clientId: "AeNdIHXHvrgacVf7bla3_PBecY3At-N4qW0Zak3FqoSHf916QOW7gHr8awtxFFoJK13oVSsXRGPq6tmy",
        const initialOptions = {
            clientId: "AVNfCZm7yHCrmr184BUuderkIHzkSgeI-GfHWDcXcRCFodOcbnR2FIG2sNBUMyv3cYxkQV_1LqRhaoZG",
            currency: "SGD",
            intent: "capture",
        };
        const styles = {
            shape: "rect",
            layout: "vertical",
        };
        if (sessionStorage.getItem("loginUserName")) {
            let loginUserName = sessionStorage.getItem("loginUserName");
            if (loginUserName !== undefined && loginUserName=== "arul.st" ) {
              this.state.showPaypalPaymentButton = true;
            }
            //Changes made to show the paypal button to all the users
            this.state.showPaypalPaymentButton = true;
          }
        return (
            <React.Fragment>
                <div className="App">
                    <PayPalScriptProvider options={initialOptions}>
                        <div className="page-content">
                            <MetaTags>
                                <title>Payment Invoice | Kattam</title>
                            </MetaTags>
                            <Container fluid className="p-0">
                                {/* Render Breadcrumbs */}
                                <Breadcrumbs title="" breadcrumbItem="Checkout" />
                                <Row>
                                    <Col lg="12">
                                        <Card>
                                            <CardBody>
                                                {/* <div className="invoice-title">
                                            <div className="mb-0">
                                                <img src={logodark} alt="logo" height="40" />
                                            </div>
                                        </div>
                                        <hr /> */}
                                                <div className="py-2 mt-0">
                                                    <h3 className="font-size-15 font-weight-bold">
                                                        Order summary
                                                    </h3>
                                                </div>
                                                <div className="table-responsive" >
                                                    <Table className="table-nowrap" style={{ backgroundColor: '#f7eacb' }}>
                                                        <thead className="thead-light" style={{ backgroundColor: '#dfb53d' }}>
                                                            <tr>
                                                                <th style={{ width: "100px" }}>Product</th>
                                                                <th>Description</th>
                                                                <th className="text-end">Price</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            <tr style={{ borderBottom: '1px solid #dfb53d' }} className="py-2">
                                                                <td>
                                                                    <br></br>
                                                                    <img src={pdficon} alt="pdficon" height="60" />
                                                                </td>
                                                                <td style={{ verticalAlign: 'middle' }}>Kattam Intelligence AI health predictive report</td>
                                                                <td className="text-end" style={{ verticalAlign: 'middle' }}>
                                                                    { }{payment.invoiceAmount}{" "}{payment.invoiceCurrency} {" "}
                                                                </td>
                                                            </tr>

                                                            <tr style={{ borderBottom: '1px solid #dfb53d' }}>
                                                                <td colSpan="2" className="border-0 text-end">
                                                                    <strong>Total</strong>
                                                                </td>
                                                                <td className="border-0 text-end">
                                                                    <h4 className="m-0">
                                                                        { }{payment.invoiceAmount}{" "}{payment.invoiceCurrency}
                                                                    </h4>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </div>
                                                <div className="d-print-none">
                                               
                                               
                                                { this.state.showPaypalPaymentButton && (

                                                    <div className="float-end">
                                                        <PayPalButtons style={styles}
                                                            createOrder={this.callCreateOrderAction}
                                                            onApprove={this.callApproveOrderAction} />
                                                    </div>
                                              )}
                                                </div>

                                                <CardText className="mt-5">
                                                </CardText>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </PayPalScriptProvider>
                </div>
                <Message content={message} />
            </React.Fragment >
        )
    }
}

BirthChartPaymentInvoice.propsTypes = {
    birthDetail: PropsTypes.object,
    loading: PropsTypes.bool,
    setMessage: PropsTypes.func,
    createOrderAction: PropsTypes.func

}

const mapStateToProps = ({ projects }) => ({
    paypalOrder: projects.paypalOrder,
    approvePaypalOrder: projects.approvePaypalOrder,
    loading: projects.loading
})

/*const mapDispatchToProps = dispatch => ({
  createOrderAction: () => dispatch(createPayPalOrder())
}) */

const mapDispatchToProps = dispatch => ({
    createOrderAction: () => {
        console.log("Dispatching createPayPalOrder action");
        dispatch(createPayPalOrder());
    },
    approveeOrderAction: (orderID, reportID) => {
        console.log("Dispatching approveeOrderAction actionjkk" + orderID + "report id=" + reportID);
        dispatch(approvePayPalOrder(orderID, reportID));
    },
    reportOrderConfirmAction: (reportID) => {
        console.log("Dispatching approveeOrderAction actionjkk" +  "report id=" + reportID);
        dispatch(reportOrderConfirm(reportID));
    }


    
});

export default connect(mapStateToProps, mapDispatchToProps)(BirthChartPaymentInvoice)
